import React from 'react'
import {Breadcrumb} from 'antd'

CustomBreadCrumb.propTypes = {}

function CustomBreadCrumb({items = []}) {
  return (
    <Breadcrumb>
      <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
      {items.map(i => (
        <Breadcrumb.Item key={i.text} {...i.link && {href: i.link}}>
          {i.text}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  )
}

export default CustomBreadCrumb
